<template>
  <el-checkbox-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    @update:modelValue="update"
  >
    <el-checkbox-button
      v-for="option in options"
      :key="option.type_id"
      :value="option.type_id"
    >
      {{ option.label }}
    </el-checkbox-button>
  </el-checkbox-group>
  <el-select
    v-else
    v-model="value"
    multiple
    :placeholder="placeholder"
    @update:modelValue="update"
  >
    <el-option
      v-for="option in options"
      :key="option.type_id"
      :label="option.type_id"
      :value="option.type_id"
    >
      {{ option.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { FeedStateLabels } from '@/api/types'
import type { FeedStateLabel } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'FeedStateSelector',
  props: {
    modelValue: {
      type: Array,
      default: () => ['review', 'new', 'approved', 'completed']
    },
    placeholder: {
      type: String,
      default: 'Select State'
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const update = function (newValue: any) {
      context.emit('update:modelValue', newValue)
    }

    const options = Object.values(FeedStateLabels).filter(
      (state): state is FeedStateLabel => Boolean(state)
    )

    const { isDesktop } = useResize()

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, isDesktop, options, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
}
</style>
